import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortConfiguration } from '../components/generics/data-table/data-table.component';
import { TipoFianza, TipoProducto } from '../models/tipo-fianza.model';
import { UtilsService } from './utils.service';

@Injectable({
    providedIn: 'root'
})
export class TiposFianzaService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService
    ) { }

    getTiposFianza(page: number, itemsPerPage: number, sorts: SortConfiguration[], tipoProducto?: TipoProducto, ocultarInactivos = true) {
        const url = '/calculadora/tipos-fianza';
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        const params: any = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts),
            'ocultar-inactivos': String(ocultarInactivos)
        };
        if (tipoProducto) {
            params['tipo-producto'] = tipoProducto;
        }
        return this.http.get<TipoFianza[]>(url, { headers, observe: 'response', params });
    }

    getTipoFianzaById(id: number) {
        return this.http.get<TipoFianza>(`/calculadora/tipos-fianza/${id}`);
    }

    createTipoFianza(tipoFianza: TipoFianza) {
        return this.http.post<TipoFianza>('/calculadora/tipos-fianza', tipoFianza);
    }

    updateTipoFianza(tipoFianza: TipoFianza) {
        return this.http.put<TipoFianza>(`/calculadora/tipos-fianza/${tipoFianza.id}`, tipoFianza);
    }

    deleteTipoFianza(id: number) {
        return this.http.delete<TipoFianza>(`/calculadora/tipos-fianza/${id}`);
    }
}
